import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
const items = ['Ebook premium "Energía Alta (Mediterránea)"', 'Plantillas de Comida Base (montaje en 60 segundos)', 'Lista de Micro-Ajustes (5–10 min) para evitar la caída', 'Guía de Cenas Inteligentes (energía sin pesadez)', 'Lista de compra "mínimo viable" (para empezar hoy)', 'Tracker de energía 16:30 (0–10) para ver progreso real', 'Plan de 14 días (ejecución sin pensar)'];
export function Deliverables() {
  return <Section className="bg-[#faf8f5]" data-id="element-93">
      <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-94">
        <div data-id="element-95">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2c4a2c] mb-4" data-id="element-96">
            Lo que te llevas (sin relleno)
          </h2>
          <p className="text-lg text-[#5a5a5a] mb-5" data-id="element-97">
            Un manual operativo para sostener energía por la tarde con comida
            mediterránea real.
          </p>

          <ul className="space-y-3 mb-6" data-id="element-98">
            {items.map((item, index) => <li key={index} className="flex items-start gap-2" data-id="element-99">
                <CheckCircle2 className="w-5 h-5 text-[#2c4a2c] shrink-0 mt-0.5" data-id="element-100" />
                <span className="text-[#2c4a2c] font-medium text-sm" data-id="element-101">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="flex flex-col sm:flex-row gap-3" data-id="element-102">
            <Button size="lg" scrollTo="pricing" data-id="element-103">
              Lo quiero
            </Button>
            <Button variant="ghost" scrollTo="pricing" data-id="element-104">
              Ver módulos
            </Button>
          </div>
        </div>

        <div className="relative" data-id="element-105">
          {/* Decorative elements */}
          <div className="absolute -z-10 top-10 -right-10 w-40 h-40 bg-[#d4a853]/20 rounded-full blur-2xl" data-id="element-106" />
          <div className="absolute -z-10 -bottom-5 -left-5 w-40 h-40 bg-[#c45d3a]/20 rounded-full blur-2xl" data-id="element-107" />
        </div>
      </div>
    </Section>;
}